<template>
  <div class="tgju-widget-content full-padding">
    <slot v-if="widgetLoad">
      <div class="text-center p-2">
        <div class="widget-loading"></div>
      </div>
    </slot>
    <div :style="'display : ' + (widgetLoad ? 'none' : 'unset')">
      <div class="list-widget list-dash-items list-widget-structure">
        <div class="tgju-widget light">
          <div id="all_summary_chart_container"></div>
          <hr />
          <ul class="chart-list-detail">
            <li>
              میانگین شاخص در بازه 1 ماهه :
              <span>
                {{ formatPrice(detail_market.one_month.month_average) }}
              </span>
            </li>
            <li>
              میزان اختلاف شاخص در روز جاری با میانگین 1 ماهه :
              <span>
                {{ formatPrice(detail_market.one_month.difference) }}
              </span>
            </li>
            <li>
              درصد اختلاف شاخص در روز جاری با میانگین 1 ماهه :
              <span>
                {{ detail_market.one_month.difference_percentage }} %
              </span>
            </li>
          </ul>
          <div id="one_month_summary_chart_container"></div>
          <hr />
          <ul class="chart-list-detail">
            <li>
              میانگین شاخص در بازه 3 ماهه :
              <span>
                {{ formatPrice(detail_market.three_month.month_average) }}
              </span>
            </li>
            <li>
              میزان اختلاف شاخص در روز جاری با میانگین 3 ماهه :
              <span>
                {{ formatPrice(detail_market.three_month.difference) }}
              </span>
            </li>
            <li>
              درصد اختلاف شاخص در روز جاری با میانگین 3 ماهه :
              <span>
                {{ detail_market.three_month.difference_percentage }} %
              </span>
            </li>
          </ul>
          <div id="three_month_summary_chart_container"></div>
          <hr />
          <ul class="chart-list-detail">
            <li>
              میانگین شاخص در بازه 6 ماهه :
              <span>
                {{ formatPrice(detail_market.six_month.month_average) }}
              </span>
            </li>
            <li>
              میزان اختلاف شاخص در روز جاری با میانگین 6 ماهه :
              <span>
                {{ formatPrice(detail_market.six_month.difference) }}
              </span>
            </li>
            <li>
              درصد اختلاف شاخص در روز جاری با میانگین 6 ماهه :
              <span>
                {{ detail_market.six_month.difference_percentage }} %
              </span>
            </li>
          </ul>
          <div id="six_month_summary_chart_container"></div>
        </div>
      </div>
    </div>
  </div>
</template>


<style lang="scss" scoped>
thead {
  display: table-header-group;
  vertical-align: middle;
  border-color: inherit;
}

.high.dir,
.low.dir {
  max-height: 25px;
  margin: 10px;
}
</style>

<script>
	// در کامپوننت تمام اجزای بخش نمودار پروفایل یک شاخص در بازار را دارا می باشد
	// نمودار تمام تواریخ
	// نمودار شش ماهه / نمودار سه ماهه
	import moment from "moment-jalaali";
	import Highcharts, { chart } from "highcharts";

	export default {
		name: "MarketProfileComponent",
		data: function () {
			return {
				widgetLoad: true,
				market_profile: [],
				summery_value: [],
				detail_market: {
					six_month: {
						month_average: 0,
						difference: 0,
						difference_percentage: 0,
						item: [],
					},
					three_month: {
						month_average: 0,
						difference: 0,
						difference_percentage: 0,
						item: [],
					},
					one_month: {
						month_average: 0,
						difference: 0,
						difference_percentage: 0,
						item: [],
					},
				},
			};
		},

  mounted() {
    this.getProfileInformaiton();
  },
  methods: {
	// این متد برای نمایش زمان به صورت رلتیو می باشد
    time() {
      return moment().format("LTS");
    },
	// این متد جهت نمایش مناسب زمان مورد استفاده قرار میگیرد
    toRelative(date) {
      if (moment().diff(moment(date), 'days') < 30)
        return moment(date).fromNow();
      else
        return moment(date).format("dddd jD jMMMM jYYYY / HH:mm");
    },
	// این متد جهت نمایش بهتر نرخ ها و قیمت ها می باشد // جدا کننده قیمت با کاما
    formatPrice(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
	// این متد وظیفه دریافت اطلاعات پروفایل شاخص (جهت نمایش نمودار تغییر در بازه های شش ماهه و سه ماهه و تمام تواریخ ) را دارد
    getProfileInformaiton() {
      this.$helpers
        .makeRequest("GET", `/market/profile/${this.$route.params.name}`)
        .then((api_response) => {
          if (api_response.status == 200) {
            this.market_profile = api_response.data.response.detail;
            this.$parent.title = this.market_profile.info.title;
            this.widgetLoad = false;

            // whole value // نمایش تمام تواریخ
            this.drawChart(
              this.market_profile.summary_table,
              "all_summary_chart_container",
              "نمودار جامع تحولات کلی شاخص"
            );

            //6 month // نمایش شش ماهه
            this.detail_market.six_month = this.calculateDifferenceDate(
              new Date().getMonth() - 6 + 1
            );

            this.drawChart(
              this.detail_market.six_month.items,
              "six_month_summary_chart_container",
              " نمودار عملکرد ۶ ماهه شاخص"
            );

            // 3 month // نمایش سه ماهه
            this.detail_market.three_month = this.calculateDifferenceDate(
              new Date().getMonth() - 3 + 1
            );

            this.drawChart(
              this.detail_market.three_month.items,
              "three_month_summary_chart_container",
              " نمودار عملکرد 3 ماهه شاخص"
            );

            // 1 month
            this.detail_market.one_month = this.calculateDifferenceDate(
              new Date().getMonth()
            );

            this.drawChart(
              this.detail_market.one_month.items,
              "one_month_summary_chart_container",
              " نمودار عملکرد 1 ماهه شاخص"
            );
          }
        });
    },
	// این متد برای محاصبخ دقیق بازه های زمانی و داده ها جهت نمایش رو نمودار مورد اسستفاده قرار میگیرد
    calculateDifferenceDate(item) {
      var data = this.market_profile.summary_table,
        sd = new Date(
          new Date().getFullYear() + "-" + item + "-" + new Date().getDate()
        ).getTime(),
        ed = new Date(new Date().toJSON().slice(0, 10)),
        result = data.filter((d) => {
          var time = new Date(d.date.replace("/", "-")).getTime();
          return sd < time && time < ed;
        });

      var sum = 0;
      console.log(result);
      result.forEach((item) => {
        sum += parseFloat(item.open.replaceAll(",", ""));
      });

      var month_average = parseInt(sum / result.length);
      var difference_between_today_balance_and_average_of_months = parseInt(
        this.market_profile.summary.price.plain - month_average
      );

      var percentage_of_difference_between_today_balance_and_average_of_months =
        parseFloat(
          ((this.market_profile.summary.price.plain - month_average) /
            this.market_profile.summary.price.plain) *
            100
        );

      return {
        month_average: month_average,
        difference: difference_between_today_balance_and_average_of_months,
        difference_percentage:
          percentage_of_difference_between_today_balance_and_average_of_months.toFixed(
            2
          ),
        items: result,
      };
    },

	// این متد جهت رسم نمودار با توجه به داده های تولید شده استفاده می شود
    drawChart(item, div = "", title = "", min = null, max = null) {
      var list = [];
      item.forEach((item) => {
        list.push([
          new Date(item.date.replaceAll("/", "-")).getTime(),
          parseInt(item.open.replaceAll(",", "")),
        ]);
      });

      Highcharts.dateFormats = {
        a: function (ts) {
          return moment(ts).format("jdddd");
        },
        A: function (ts) {
          return moment(ts).format("jdddd");
        },
        d: function (ts) {
          return moment(ts).format("jDD");
        },
        e: function (ts) {
          return moment(ts).format("jD");
        },
        b: function (ts) {
          return moment(ts).format("jMMMM");
        },
        B: function (ts) {
          return moment(ts).format("jMMMM");
        },
        m: function (ts) {
          return moment(ts).format("jMM");
        },
        y: function (ts) {
          return moment(ts).format("jYY");
        },
        Y: function (ts) {
          return moment(ts).format("jYYYY");
        },
        W: function (ts) {
          return moment(ts).format("jww");
        },
      };

      //Draw Chart
      Highcharts.chart(div, {
        chart: {
          zoomType: "x",
        },

        title: {
          text: title,
        },

        tooltip: {
          valueDecimals: 0,
        },

        xAxis: {
          type: "datetime",
          title: {
            text: "زمان",
          },
        },
        yAxis: {
          title: {
            text: "بازه قیمت",
          },
        },
        series: [
          {
            data: list,
            lineWidth: 1,
            title: "زمان",
          },
        ],
      });
    },
  },
};
</script>